import type { ColumnDef } from '@/shared/types/table-filters.types';
import type { SuperAdmin } from '../types/super-admin.types';

/**
 * Filterable/sortable super admin fields, shared by the desktop table and the mobile cards.
 * Role is deliberately absent: every row on this screen is a SUPER_ADMIN.
 */
export const superAdminTableColumns: ColumnDef<SuperAdmin>[] = [
  {
    key: 'name',
    label: 'Name',
    filterType: 'text',
    accessor: (superAdmin) => superAdmin.profile.fullName,
    sortable: true,
  },
  {
    key: 'email',
    label: 'Email',
    filterType: 'text',
    accessor: (superAdmin) => superAdmin.email,
    sortable: true,
  },
  {
    key: 'isActive',
    label: 'Active',
    filterType: 'boolean',
    accessor: (superAdmin) => superAdmin.isActive,
    sortable: true,
  },
  {
    key: 'lastLoginAt',
    label: 'Last login',
    filterType: 'date-range',
    accessor: (superAdmin) => superAdmin.lastLoginAt,
    sortable: true,
  },
  {
    key: 'createdAt',
    label: 'Created',
    filterType: 'date-range',
    accessor: (superAdmin) => superAdmin.createdAt,
    sortable: true,
  },
];
